module.exports = __webpack_public_path__ + "img/Marketing_case_pic02.34db7968.png";